import { useI18n } from '@/shared/i18n/useT';

/** Marks a file shared with this person that they haven't opened yet. */
export function NewBadge() {
  const { t } = useI18n();
  return (
    <span className="shrink-0 rounded-full bg-accent px-1.5 py-px text-[0.625rem] font-semibold uppercase leading-4 tracking-wide text-accent-fg">
      {t('home.newBadge')}
    </span>
  );
}
